<template>
  <div class="user-center-container">
    <div class="main-content">
      <div class="user-info-card">
        <el-card>
          <div slot="header" class="card-header">
            <i class="el-icon-user"></i>
            <span>个人信息</span>
          </div>
          <div class="user-info">
            <div class="avatar">
              <img :src="userInfo.icon || 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'" alt="头像" />
              <div class="avatar-overlay" @click="triggerUpload">
                <i class="el-icon-camera"></i>
                <span>更换头像</span>
              </div>
              <input 
                ref="avatarInput" 
                type="file" 
                accept="image/*" 
                style="display: none"
                @change="handleAvatarChange"
              />
            </div>
            <div class="info-list">
              <div class="info-item">
                <span class="label"><i class="el-icon-user"></i> 用户名：</span>
                <span class="value">{{ userInfo.userName }}</span>
              </div>
              <div class="info-item">
                <span class="label"><i class="el-icon-message"></i> 账号：</span>
                <span class="value">{{ userInfo.userAccount }}</span>
              </div>
              <div class="info-item">
                <span class="label"><i class="el-icon-phone"></i> 手机号：</span>
                <span class="value">{{ userInfo.userPhone }}</span>
              </div>
              <div class="info-item">
                <span class="label"><i class="el-icon-email"></i> 邮箱：</span>
                <span class="value">{{ userInfo.emailAddress }}</span>
              </div>
              <div class="info-item">
                <span class="label"><i class="el-icon-time"></i> 注册时间：</span>
                <span class="value">{{ userInfo.createTime }}</span>
              </div>
              <div class="info-item">
                <span class="label"><i class="el-icon-rank"></i> 用户等级：</span>
                <span class="value">
                  <el-tag :type="getLevelType(userInfo.userLevel)" size="small">
                    {{ userInfo.userLevel }}级
                  </el-tag>
                </span>
              </div>
              <div class="info-actions">
                <el-button type="primary" size="small" @click="openEditInfoDialog">
                  <i class="el-icon-edit"></i> 修改信息
                </el-button>
                <el-button type="warning" size="small" @click="openEditPasswordDialog">
                  <i class="el-icon-lock"></i> 修改密码
                </el-button>
              </div>
            </div>
          </div>
        </el-card>
      </div>

      <div class="my-content-card">
        <el-card>
          <el-tabs v-model="activeTab" @tab-click="handleTabClick">
            <el-tab-pane label="我的文章" name="posts">
              <div class="filter-bar">
                <CategorySelect 
                  v-model="selectedCategory" 
                  placeholder="全部分类"
                  size="small"
                  custom-style="width: 150px; margin-right: 10px;"
                  @change="getPostList"
                />
                <el-select 
                  v-model="articleStatus" 
                  placeholder="文章状态" 
                  size="small" 
                  style="width: 120px; margin-right: 10px;" 
                  clearable
                  @change="getPostList"
                >
                  <el-option label="全部状态" value=""></el-option>
                  <el-option label="待审核" value="2"></el-option>
                  <el-option label="已发布" value="1"></el-option>
                  <el-option label="已拒绝" value="0"></el-option>
                </el-select>
                <el-date-picker
                  v-model="dateRange"
                  type="daterange"
                  size="small"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  default-time="['00:00:00', '23:59:59']"
                  style="width: 240px; margin-right: 10px;"
                  @change="getPostList"
                ></el-date-picker>
                <el-button type="primary" size="small" @click="goPublish">
                  <i class="el-icon-edit"></i> 发表文章
                </el-button>
              </div>
              <ul class="post-list">
                <li class="post-item" v-for="post in postList" :key="post.docDigest" @click="goDetail(post.docDigest)">
                  <div class="post-content">
                    <h4 class="post-title">{{ post.title }}</h4>
                    <div class="post-meta">
                      <span><i class="el-icon-time"></i> {{ post.createTime }}</span>
                      <span><i class="el-icon-star-on"></i> {{ post.praiseCount || 0 }} 点赞</span>
                      <span><i class="el-icon-chat-dot-round"></i> {{ post.commentCount || 0 }} 评论</span>
                    </div>
                  </div>
                  <div class="post-action">
                    <el-button size="mini" type="text">查看详情</el-button>
                  </div>
                </li>
              </ul>
              <el-empty v-if="postList.length === 0 && !loading" description="暂无文章"></el-empty>
              <div class="loading-status" v-if="loading">
                <i class="el-icon-loading"></i>
                <span>加载中...</span>
              </div>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNumber"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageTotal"
                style="margin-top: 20px; justify-content: flex-end"
              ></el-pagination>
            </el-tab-pane>

            <el-tab-pane label="我的关注" name="follows">
              <div class="follow-list">
                <div class="follow-item" v-for="user in followList" :key="user.followUserId">
                  <div class="follow-user-info" @click="goToUserCenter(user.followUserId)">
                    <el-avatar :size="50" :src="user.followUserIcon" icon="el-icon-user"></el-avatar>
                    <div class="user-detail">
                      <div class="user-name">{{ user.followUserName }}</div>
                      <div class="user-stats">
                        <span><i class="el-icon-document"></i> {{ user.followCount || 0 }} 关注</span>
                        <span><i class="el-icon-user-solid"></i> {{ user.followerCount || 0 }} 粉丝</span>
                      </div>
                    </div>
                  </div>
                  <el-button 
                    size="small" 
                    type="primary" 
                    plain
                    @click="toggleFollow(user.followUserId)"
                  >
                    {{ user.isFollowed ? '已关注' : '+ 关注' }}
                  </el-button>
                </div>
                <el-empty v-if="followList.length === 0" description="暂无关注"></el-empty>
              </div>
            </el-tab-pane>

            <el-tab-pane label="我的粉丝" name="followers">
              <div class="follow-list">
                <div class="follow-item" v-for="user in followerList" :key="user.followUserId">
                  <div class="follow-user-info" @click="goToUserCenter(user.followUserId)">
                    <el-avatar :size="50" :src="user.followUserIcon" icon="el-icon-user"></el-avatar>
                    <div class="user-detail">
                      <div class="user-name">{{ user.followUserName }}</div>
                      <div class="user-stats">
                        <span><i class="el-icon-document"></i> {{ user.followCount || 0 }} 关注</span>
                        <span><i class="el-icon-user-solid"></i> {{ user.followerCount || 0 }} 粉丝</span>
                      </div>
                    </div>
                  </div>
                  <el-button 
                    size="small" 
                    type="primary" 
                    plain
                    v-if="!user.isFollowed"
                    @click="toggleFollow(user.followUserId)"
                  >
                    + 回关
                  </el-button>
                  <el-tag v-else size="small" type="success">已互相关注</el-tag>
                </div>
                <el-empty v-if="followerList.length === 0" description="暂无粉丝"></el-empty>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </div>
    </div>

    <el-dialog title="修改个人信息" :visible.sync="editInfoDialogVisible" width="500px">
      <el-form :model="editInfoForm" :rules="editInfoRules" ref="editInfoForm" label-width="80px">
        <el-form-item label="用户名" prop="userName">
          <el-input v-model="editInfoForm.userName" placeholder="请输入用户名" maxlength="20" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="emailAddress">
          <el-input v-model="editInfoForm.emailAddress" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item label="头像" prop="icon">
          <el-input v-model="editInfoForm.icon" placeholder="头像地址" readonly>
            <el-button slot="append" @click="triggerUpload">选择头像</el-button>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="editInfoDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEditInfo" :loading="submitLoading">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog title="修改密码" :visible.sync="editPasswordDialogVisible" width="450px">
      <el-form :model="editPasswordForm" :rules="editPasswordRules" ref="editPasswordForm" label-width="100px">
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input v-model="editPasswordForm.oldPassword" type="password" placeholder="请输入旧密码" show-password></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="editPasswordForm.newPassword" type="password" placeholder="请输入新密码" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input v-model="editPasswordForm.confirmPassword" type="password" placeholder="请再次输入新密码" show-password></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="editPasswordDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEditPassword" :loading="submitLoading">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CategorySelect from '../components/CategorySelect.vue';
export default {
  name: 'UserCenter',
  components: {
    CategorySelect
  },
  data() {
    return {
      userInfo: {},
      postList: [],
      followList: [],
      followerList: [],
      pageNumber: 1,
      pageSize: 10,
      pageTotal: 0,
      selectedCategory: 0,
      articleStatus: '',
      dateRange: [],
      activeTab: 'posts',
      loading: false,
      uploadLoading: false,
      submitLoading: false,
      editInfoDialogVisible: false,
      editPasswordDialogVisible: false,
      editInfoForm: {
        userName: '',
        emailAddress: '',
        icon: ''
      },
      editInfoRules: {
        userName: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 4, max: 20, message: '长度在 4 到 20 个字符', trigger: 'blur' }
        ],
        emailAddress: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' }
        ]
      },
      editPasswordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      editPasswordRules: {
        oldPassword: [
          { required: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: (rule, value, callback) => {
              if (value !== this.editPasswordForm.newPassword) {
                callback(new Error('两次输入的密码不一致'));
              } else {
                callback();
              }
            }, trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    this.getUserInfo();
    this.getPostList();
    this.getFollowList();
  },
  methods: {
    async getUserInfo() {
      try {
        const loginResult = JSON.parse(localStorage.getItem('loginResult') || '{}');
        const response = await this.$axios({
          method: 'post',
          url: '/user/getUser',
          data: {
            userId: loginResult.userId || ''
          }
        });
        if (response.code === '200' || response.code === 200) {
          this.userInfo = response.data;
        }
      } catch (error) {
        console.error('获取用户信息失败:', error);
      }
    },
    getPostList() {
      this.loading = true;
      const loginResult = JSON.parse(localStorage.getItem('loginResult') || '{}');
      const data = {
        pageNum: this.pageNumber,
        pageSize: this.pageSize,
        order: 'time',
        queryUserId: loginResult.userId
      };
      
      if (this.selectedCategory && this.selectedCategory !== 0) {
        data.categoryId = this.selectedCategory;
        data.includeSubCategories = true;
      }
      
      if (this.articleStatus) {
        data.state = this.articleStatus;
      }
      
      if (this.dateRange && this.dateRange.length === 2) {
        data.startTime = this.dateRange[0];
        data.endTime = this.dateRange[1];
      }
      
      this.$axios({
        method: 'post',
        url: '/doc/loginQueryUserDocList',
        data: data
      })
        .then(response => {
          this.loading = false;
          if (response.code == 200) {
            this.postList = response.data.data || [];
            this.pageTotal = response.data.total || 0;
          } else {
            this.$message.error(response.msg || '获取文章列表失败');
          }
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
          this.$message.error('获取文章列表失败');
        });
    },
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.getPostList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNumber = 1;
      this.getPostList();
    },
    goDetail(id) {
      this.$router.push({ name: 'Content', params: { id: id } });
    },
    goPublish() {
      this.$router.push({ name: 'Publish' });
    },
    async getFollowList() {
      const loginResult = JSON.parse(localStorage.getItem('loginResult') || '{}');
      try {
        const response = await this.$axios({
          method: 'post',
          url: '/userfollow/followList',
          data: {
            userId: loginResult.userId || ''
          }
        });
        if (response.code === '200' || response.code === 200) {
          this.followList = response.data || [];
        }
      } catch (error) {
        console.error('获取关注列表失败:', error);
      }
    },
    async toggleFollow(followUserId) {
      const loginResult = JSON.parse(localStorage.getItem('loginResult') || '{}');
      const user = this.followList.find(u => u.followUserId === followUserId);
      
      try {
        const url = user && user.isFollowed ? '/userfollow/unfollow' : '/userfollow/follow';
        const response = await this.$axios({
          method: 'post',
          url: url,
          data: {
            userId: loginResult.userId || '',
            followUserId: followUserId
          }
        });
        
        if (response.code === '200' || response.code === 200) {
          this.$message.success(user && user.isFollowed ? '取消关注成功' : '关注成功');
          this.getFollowList();
        } else {
          this.$message.error(response.msg || '操作失败');
        }
      } catch (error) {
        console.error('操作失败:', error);
        this.$message.error('操作失败');
      }
    },
    goToUserCenter(userId) {
      const loginResult = JSON.parse(localStorage.getItem('loginResult') || '{}');
      if (loginResult.userId && loginResult.userId.toString() === userId.toString()) {
        this.$router.push({ name: 'UserCenter' });
      } else {
        this.$router.push({ name: 'OtherUserCenter', params: { userId: userId } });
      }
    },
    handleTabClick(tab) {
      if (tab.name === 'follows' && this.followList.length === 0) {
        this.getFollowList();
      } else if (tab.name === 'followers' && this.followerList.length === 0) {
        this.getFollowerList();
      }
    },
    async getFollowerList() {
      const loginResult = JSON.parse(localStorage.getItem('loginResult') || '{}');
      try {
        const response = await this.$axios({
          method: 'post',
          url: '/userfollow/followerList',
          data: {
            userId: loginResult.userId || ''
          }
        });
        if (response.code === '200' || response.code === 200) {
          this.followerList = response.data || [];
        }
      } catch (error) {
        console.error('获取粉丝列表失败:', error);
      }
    },
    openEditInfoDialog() {
      this.editInfoForm = {
        userName: this.userInfo.userName || '',
        emailAddress: this.userInfo.emailAddress || '',
        icon: this.userInfo.icon || ''
      };
      this.editInfoDialogVisible = true;
    },
    openEditPasswordDialog() {
      this.editPasswordForm = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      };
      this.editPasswordDialogVisible = true;
    },
    submitEditInfo() {
      this.$refs.editInfoForm.validate(async (valid) => {
        if (!valid) return;
        this.submitLoading = true;
        const loginResult = JSON.parse(localStorage.getItem('loginResult') || '{}');
        try {
          const response = await this.$axios({
            method: 'post',
            url: '/user/updateUserInfo',
            data: {
              userId: loginResult.userId || '',
              changeUserName: this.editInfoForm.userName,
              emailAddress: this.editInfoForm.emailAddress,
              icon: this.editInfoForm.icon
            }
          });
          if (response.code === '200' || response.code === 200) {
            this.$message.success('修改成功');
            this.editInfoDialogVisible = false;
            this.getUserInfo();
          } else {
            this.$message.error(response.msg || '修改失败');
          }
        } catch (error) {
          console.error('修改失败:', error);
          this.$message.error('修改失败');
        } finally {
          this.submitLoading = false;
        }
      });
    },
    submitEditPassword() {
      this.$refs.editPasswordForm.validate(async (valid) => {
        if (!valid) return;
        this.submitLoading = true;
        const loginResult = JSON.parse(localStorage.getItem('loginResult') || '{}');
        try {
          const response = await this.$axios({
            method: 'post',
            url: '/user/updateUserPassword',
            data: {
              userId: loginResult.userId || '',
              oldPassword: this.editPasswordForm.oldPassword,
              newPassword: this.editPasswordForm.newPassword
            }
          });
          if (response.code === '200' || response.code === 200) {
            this.$message.success('密码修改成功，请重新登录');
            this.editPasswordDialogVisible = false;
            setTimeout(() => {
              this.$store.commit('logout');
              this.$router.push({ name: 'Login' });
            }, 1500);
          } else {
            this.$message.error(response.msg || '修改失败');
          }
        } catch (error) {
          console.error('修改失败:', error);
          this.$message.error('修改失败');
        } finally {
          this.submitLoading = false;
        }
      });
    },
    triggerUpload() {
      this.$refs.avatarInput.click();
    },
    async handleAvatarChange(event) {
      const file = event.target.files[0];
      if (!file) return;

      const maxSize = 5 * 1024 * 1024;
      if (file.size > maxSize) {
        this.$message.error('头像文件大小不能超过 5MB');
        return;
      }

      const validTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
      if (!validTypes.includes(file.type)) {
        this.$message.error('只支持 JPG、PNG、GIF、WEBP 格式的头像');
        return;
      }

      this.uploadLoading = true;
      const formData = new FormData();
      formData.append('file', file);
      formData.append('path', 'avatar/' + new Date().getFullYear() + '/' + (new Date().getMonth() + 1));

      try {
        const response = await this.$axios({
          method: 'post',
          url: '/file/upload',
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        if (response.code === '200' || response.code === 200) {
          const avatarUrl = response.data;
          await this.updateUserInfo(avatarUrl);
        } else {
          this.$message.error(response.msg || '上传失败');
        }
      } catch (error) {
        console.error('上传头像失败:', error);
        this.$message.error('上传失败');
      } finally {
        this.uploadLoading = false;
        event.target.value = '';
      }
    },
    async updateUserInfo(iconUrl) {
      const loginResult = JSON.parse(localStorage.getItem('loginResult') || '{}');
      try {
        const response = await this.$axios({
          method: 'post',
          url: '/user/updateUserIcon',
          data: {
            userId: loginResult.userId || '',
            icon: iconUrl
          }
        });

        if (response.code === '200' || response.code === 200) {
          this.$message.success('头像更新成功');
          this.userInfo.icon = iconUrl;
          loginResult.icon = iconUrl;
          localStorage.setItem('loginResult', JSON.stringify(loginResult));
          this.$store.commit('updateIcon', iconUrl);
        } else {
          this.$message.error(response.msg || '更新失败');
        }
      } catch (error) {
        console.error('更新头像失败:', error);
        this.$message.error('更新失败');
      }
    },
    getLevelType(level) {
      if (level >= 999) return 'danger';
      if (level >= 100) return 'warning';
      if (level >= 10) return 'success';
      return 'info';
    }
  }
};
</script>

<style scoped lang="less">
.user-center-container {
  min-height: calc(100vh - 64px);
  margin-top: 64px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 24px;

  .main-content {
    max-width: 1200px;
    margin: 0 auto;

    .user-info-card {
      margin-bottom: 24px;

      ::v-deep .el-card {
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);

        .card-header {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 18px;
          font-weight: 600;
          color: #333;

          i {
            color: #667eea;
            font-size: 22px;
          }
        }
      }

      .user-info {
        display: flex;
        gap: 32px;
        padding: 20px;

        .avatar {
          flex-shrink: 0;
          position: relative;
          display: inline-block;

          img {
            width: 120px;
            height: 120px;
            border-radius: 50%;
            object-fit: cover;
            border: 4px solid #667eea;
            box-shadow: 0 4px 16px rgba(102, 126, 234, 0.3);
          }

          .avatar-overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border-radius: 50%;
            background: rgba(0, 0, 0, 0.5);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            color: #fff;
            opacity: 0;
            transition: opacity 0.3s;
            cursor: pointer;

            i {
              font-size: 24px;
              margin-bottom: 4px;
            }

            span {
              font-size: 12px;
            }
          }

          &:hover .avatar-overlay {
            opacity: 1;
          }
        }

        .info-list {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 16px;

          .info-item {
            display: flex;
            align-items: center;
            font-size: 15px;

            .label {
              width: 120px;
              color: #666;
              display: flex;
              align-items: center;
              gap: 6px;

              i {
                color: #667eea;
              }
            }

            .value {
              color: #333;
              font-weight: 500;
            }
          }

          .info-actions {
            display: flex;
            gap: 12px;
            margin-top: 16px;
            padding-top: 16px;
            border-top: 1px solid #eee;
          }
        }
      }
    }

    .my-posts-card {
      ::v-deep .el-card {
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);

        .card-header {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 18px;
          font-weight: 600;
          color: #333;

          i {
            color: #667eea;
            font-size: 22px;
          }
        }
      }

      .filter-bar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        padding: 16px;
        background: #f8f9fa;
        border-radius: 8px;
      }

      .post-list {
        list-style: none;
        padding: 0;
        margin: 0;

        .post-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 20px;
          margin-bottom: 16px;
          background: #fff;
          border: 1px solid #e8e8e8;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.3s;

          &:hover {
            border-color: #667eea;
            box-shadow: 0 4px 16px rgba(102, 126, 234, 0.15);
            transform: translateY(-2px);
          }

          .post-content {
            flex: 1;

            .post-title {
              margin: 0 0 12px;
              font-size: 16px;
              font-weight: 600;
              color: #333;
            }

            .post-meta {
              display: flex;
              gap: 20px;
              font-size: 13px;
              color: #999;

              span {
                display: flex;
                align-items: center;
                gap: 4px;

                i {
                  color: #667eea;
                }
              }
            }
          }

          .post-action {
            flex-shrink: 0;
            margin-left: 20px;
          }
        }
      }

      .loading-status {
        text-align: center;
        padding: 20px;
        color: #999;
        font-size: 14px;

        i {
          margin-right: 8px;
        }
      }

      ::v-deep .el-pagination {
        .el-pager li {
          border-radius: 6px;
          min-width: 36px;
          height: 36px;
          line-height: 36px;
          font-weight: 500;

          &.active {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: #fff;
          }

          &:hover {
            background: #667eea;
            color: #fff;
          }
        }
      }
    }
  }
}

.my-content-card {
  margin-top: 24px;

  ::v-deep .el-card {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);

    .el-tabs__header {
      margin: 0 0 20px;
      padding: 0 20px;
      background: #f8f9fa;

      .el-tabs__item {
        font-size: 16px;
        font-weight: 600;
        padding: 16px 24px;

        &.is-active {
          color: #667eea;
        }
      }
    }
  }

  .filter-bar {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding: 16px;
    background: #f8f9fa;
    border-radius: 8px;
  }

  .post-list {
    list-style: none;
    padding: 0;
    margin: 0;

    .post-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px;
      margin-bottom: 16px;
      background: #fff;
      border: 1px solid #e8e8e8;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        border-color: #667eea;
        box-shadow: 0 4px 16px rgba(102, 126, 234, 0.15);
        transform: translateY(-2px);
      }

      .post-content {
        flex: 1;

        .post-title {
          margin: 0 0 12px;
          font-size: 16px;
          font-weight: 600;
          color: #333;
        }

        .post-meta {
          display: flex;
          gap: 20px;
          font-size: 13px;
          color: #999;

          span {
            display: flex;
            align-items: center;
            gap: 4px;

            i {
              color: #667eea;
            }
          }
        }
      }

      .post-action {
        flex-shrink: 0;
        margin-left: 20px;
      }
    }
  }

  .follow-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;

    .follow-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px;
      background: #fff;
      border: 1px solid #e8e8e8;
      border-radius: 8px;
      transition: all 0.3s;

      &:hover {
        border-color: #667eea;
        box-shadow: 0 4px 16px rgba(102, 126, 234, 0.15);
      }

      .follow-user-info {
        display: flex;
        align-items: center;
        gap: 16px;
        cursor: pointer;
        flex: 1;

        .user-detail {
          .user-name {
            font-size: 15px;
            font-weight: 600;
            color: #333;
            margin-bottom: 4px;
          }

          .user-stats {
            display: flex;
            gap: 16px;
            font-size: 13px;
            color: #999;

            span {
              display: flex;
              align-items: center;
              gap: 4px;

              i {
                color: #667eea;
              }
            }
          }
        }
      }
    }
  }

  .loading-status {
    text-align: center;
    padding: 20px;
    color: #999;
    font-size: 14px;

    i {
      margin-right: 8px;
    }
  }

  ::v-deep .el-pagination {
    .el-pager li {
      border-radius: 6px;
      min-width: 36px;
      height: 36px;
      line-height: 36px;
      font-weight: 500;

      &.active {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: #fff;
      }

      &:hover {
        background: #667eea;
        color: #fff;
      }
    }
  }
}

@media (max-width: 768px) {
  .user-center-container {
    padding: 16px;

    .main-content {
      .user-info-card {
        .user-info {
          flex-direction: column;
          align-items: center;
          text-align: center;

          .info-list {
            .info-item {
              justify-content: center;

              .label {
                width: auto;
              }
            }
          }
        }
      }

      .my-content-card {
        .post-list {
          .post-item {
            flex-direction: column;
            align-items: flex-start;
            gap: 16px;

            .post-action {
              margin-left: 0;
            }
          }
        }

        .follow-list {
          .follow-item {
            flex-direction: column;
            gap: 12px;

            .follow-user-info {
              width: 100%;
            }

            .el-button {
              width: 100%;
            }
          }
        }
      }
    }
  }
}
</style>
